import { USER_KEY } from '../constants'

export default () => {
  const { retailerId } = JSON.parse(localStorage.getItem(USER_KEY) || '{}')
  return retailerId;
}
